import apiActionsTypes from './api-action-types';
import { getAllStatesRequest } from '../services/api';

const getStatesList = () => {
  return async (dispatch) => {
    dispatch({
      type: apiActionsTypes.GET_STATES_DATA_START,
    });

    try {
      const statesList = await getAllStatesRequest();
      dispatch({
        type: apiActionsTypes.GET_STATES_DATA_SUCCESS,
        data: statesList,
      });
    } catch (error) {
      dispatch({
        type: apiActionsTypes.GET_STATES_DATA_FAIL,
        data: error.toJSON(),
      });
    }
  };
};

export default getStatesList;
